module.exports = __webpack_public_path__ + "assets/images/rbyearend-06.jpg?v=741d8b07";